import React,{useState,useEffect} from 'react'
import {MetadataOption} from 'api'
import {Icon} from 'antd'
import './index.less'

interface AppMultCheckProps {
	options?: MetadataOption[]
	value?: string[]
	onChange?: (value: string[]) => void
}

interface MultCheckOption extends MetadataOption{
	checked?:boolean
}

const initCheckOption = (props:AppMultCheckProps) =>{
	let arr: MultCheckOption[] = [];
	props.options && props.options.map((option:MetadataOption)=>{
		let checked = false;
		if(props.value && props.value.find(o => o === option.value)) checked = true;
		arr.push({...option,checked})
	})
	return arr;
}

const getReturnValue = (options:MultCheckOption[]) =>{
	let returnValue :string[] = [];
	options.map((option:MultCheckOption)=>{
		if(option.checked) returnValue.push (option.value||'')
	})
	return returnValue;
}


export const AppMultCheck = (props: AppMultCheckProps) => {
	const [showMoreItem, setShowMoreItem] = useState(false)
	const [showMoreLink,setShowMoreLink] = useState(false)
	const [options,setOptions] = useState(initCheckOption(props))

	useEffect(() => {
		setShowMoreLink(refDivContainer.current.clientHeight < refOptionsList.current.clientHeight)
	}, [])

	let allChecked =  (options.filter(e => !e.checked).length === 0 || options.filter(e => e.checked).length === 0)

	const handleItemClick = (eventData:MultCheckOption) =>{
		let newEventData = {...eventData,checked:!eventData.checked}
		let newOptions = options.map((option:MultCheckOption)=>{
			return option.value === newEventData.value ? {...newEventData}:{...option};
		})
		props.onChange && props.onChange(getReturnValue(newOptions));
		setOptions(newOptions);
	}


	const handleAllChecked = () =>{
		if(options.length===0) return;
		let checked = (options.filter(e => e.checked).length === 0);
		let newOptions:MultCheckOption[] = [];
		options.map((option:MultCheckOption)=>{
			newOptions.push({...option,checked})
		})
		props.onChange && props.onChange(getReturnValue(newOptions))
		setOptions(newOptions)
	}

	const refDivContainer = React.createRef<HTMLDivElement>()
	const refOptionsList = React.createRef<HTMLDivElement>()

	const renderMore = ()=>{
		if(!showMoreLink) return <React.Fragment/>;
		let text = showMoreItem ? '收起' : '更多';
		let iconType = showMoreItem ? 'up' : 'down';
		return (
		<span 
			className='app-mult-check-item-more' 
			onClick={()=>{let newShowMoreItem = !showMoreItem; setShowMoreItem(newShowMoreItem)}}>
			{text}
			<Icon className='item-more-icon' type={iconType}/>
		</span>)
	}

	const renderItemList = () =>{
		return (
		<div className='app-mult-check-item-list' ref={refOptionsList}>
			{options.map((option:MultCheckOption,index:number)=>{
				return (
					<span 
						key={index} 
						onClick={()=> handleItemClick(option)}
						className='app-mult-check-item' 
						data-checked={option.checked}>
						{option.label}
						<i className="qcciconfont-select app-all-option-checked-icon" hidden={!option.checked} />
					</span>
				);
			})}
		</div>);
	}

	return (
	<div className='app-mult-check-container'>
		<div className='app-mult-check-left'>
			<div className='app-mult-check-all-content'>
				<span className='app-all-option' 
					data-checked={allChecked} 
					onClick={handleAllChecked}>全部
					<i className="qcciconfont-select app-all-option-checked-icon" 
					hidden={!allChecked} />
				</span>
			</div>
		</div>
		<div className='app-mult-check-right'>
			<div className='app-mult-check-item-outer'>
				<div className='app-mult-check-item-inner'>
					<div 
						style={showMoreItem ? { height: 'auto' } : {}}
						className='app-mult-check-item-content' 
						ref={refDivContainer}>
						{renderItemList()}
						{renderMore()}
					</div>
				</div>
			</div>
		</div>
	</div>
	)
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppMultCheck.tsx